import React from 'react'
import './Navlist.css'
import { getRandomdata } from '../../../api'
import icon_home from '../../../img/home.png'
import icon_random from '../../../img/random.png'
import icon_privacy from '../../../img/privacy.png'
import { useEffect, useState } from 'react'


export default function Navlist({ flag, setNav }) {
  const [link, setLink] = useState();
  /* const goHome = () => {
    window.location = "/";
  } */

  /* const goPolicy = () => {
    window.location = "/policy.html";
  } */

  /* const { search } = useLocation(); */
  /* const resSearch = search.substring(1); */

  // 随机按钮
  const randomBtn = async () => {
    // console.log(resSearch.split('=')[1]);
    let target = await getRandomdata().then(res => {
      // console.log(res.data.data);
      return res.data.data[Math.floor(Math.random() * res.data.data.length + 1)]
    })

    setLink(target);
  }

  useEffect(() => {
    randomBtn();
  }, [])

  return (
    <div className={flag ? 'nav_list nav_visible' : 'nav_list'}>

      <ul>
        <li>
          <a href='/randomhow/index.html' className='btn_a' style={{ color: 'white' }}>
            <img src={icon_home} alt="" />
            <span>Home</span>
          </a>

        </li>

        <li>
          <a href={link} className='btn_a' style={{ color: 'white' }}>
            <img src={icon_random} alt="" />
            <span>Random</span>
          </a>

        </li>

        <li>
          <a href="/policy.html" className='btn_a' style={{ color: 'white' }}>
            <img src={icon_privacy} alt="" />
            <span>Privacy Policy</span>
          </a>

        </li>

      </ul>

      <div className="blank" onClick={setNav}></div>

    </div>
  )
}
